<template>
  <div class="industury">
    <router-view />
    <div class="industury__topbanner">
      <ul v-if="$root.globalData">
        <li>{{$root.globalData.keys.about_us_text}}</li>
        <span> <DoubleLeftAroow /> </span>
        <li>
          <router-link style="color: white" to="/"> {{$root.globalData.keys.home_index_text}} </router-link>
        </li>
      </ul>
    </div>

    <section class="about margin w">
      
      <div v-if="$root.globalData"
        data-aos="fade-left"
        data-aos-duration="1500"
        class="about__RightBox"
      >
        <h4>
          {{ $root.globalData.keys.aboutUs_title }}
        </h4>
        <div v-html="$root.globalData.keys.aboutUs_description" />

        
      </div>

      <div v-if="$root.globalData" class="about__LeftBox">
        <img
          data-aos="fade-right"
          data-aos-duration="1000"
          class="aboutImage aboutImage1"
          :src="'https://gorgon.ir/storage/'+$root.globalData.settings.aboutUs_1_img"
          alt="about image"
        />
        <img
          data-aos="fade-right"
          data-aos-duration="2000"
          class="aboutImage aboutImage2"
          :src="'https://gorgon.ir/storage/'+$root.globalData.settings.aboutUs_2_img"
          alt="about image"
        />
        <img
          data-aos="fade-right"
          data-aos-duration="1000"
          class="aboutImage aboutImage3"
          :src="'https://gorgon.ir/storage/'+$root.globalData.settings.aboutUs_3_img"
          alt="about image"
        />
        <img
          data-aos="fade-right"
          data-aos-duration="3000"
          class="aboutImage aboutImage4"
          :src="'https://gorgon.ir/storage/'+$root.globalData.settings.aboutUs_4_img"
          alt="about image"
        />
      </div>

    </section>
  </div>
</template> 


<script>
import DoubleLeftAroow from "../components/svgs/DoubleLeftAroow.vue";
import IndusturyFilter from "../components/main/IndusturyFilter.vue";
// import RateFilter from "../components/main/RateFilter.vue";
import BlogSliderFilter from "../components/main/BlogSliderFilter.vue";
import ArrowDown from "../components/svgs/ArrowDown.vue";
import HamburgetMenuIcon3 from "../components/svgs/HamburgetMenuIcon3.vue";
import HamburgerMenuIcon2 from "../components/svgs/HamburgerMenuIcon2.vue";

export default {
  data() {
    return {
      cardboxitems: 9,
      ShowingCard: false,
      AboutTitle: "درباری اینیاب",
      AboutText:
        " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است که برای امتحان فونت و یا پر کردن فضا در یک طراحی گرافیکی و یا صنعت چاپ استفاده میشود. طراحان وب و گرافیک از این متن برای پرکردن صفحه و ارائه شکل کلی طرح استفاده می‌کنند.",
    };
  },

  methods: {
    cardbox() {
      // this.ShowingCard =
    },

    CardBoxShow() {},
  },
  components: {
    DoubleLeftAroow,
    IndusturyFilter,
    // RateFilter,
    BlogSliderFilter,
    ArrowDown,
    HamburgetMenuIcon3,
    HamburgerMenuIcon2,
  },
  
  metaInfo() {
        return { 
            title: "درباره ما",
            meta: [
                { name: 'description', content:  'درباره ما'},
                { property: 'og:title', content: "درباره ما"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>


<style scoped>
.industury {
  background-color: #f1f0f0;
}
.industury__topbanner {
  width: 100%;
  height: 200px;
  background-image: url(../assets/images/industrybanner.jpg);
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

ul li {
  font-size: 20px;
  cursor: pointer;
}

/* about body styles  */

.about {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 3rem 0;
  gap: 20px;
}

.about__RightBox {
  grid-column: 1 / span 5;
  direction: rtl;
  text-align: right;
  padding: 0 1rem;
}

.about__RightBox h4 {
  color: #0d6efd;
  font-size: 20px;
  font-weight: bolder;
  margin-bottom: 1.5rem;
}

.about__RightBox p {
  font-size: 15px;
  text-align: justify;
  line-height: 2;
}
.about__LeftBox {
  grid-column: 6/ -1;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(2, 300px);
  gap: 20px;
}

.about__LeftBox img {
  width: 100%;
  height: 100%;
}

.aboutImage1 {
  grid-column: 1 / span 4;
}
.aboutImage2 {
  grid-column: 5/ -1;
}
.aboutImage3 {
  grid-column: 1 / span 5;
}
.aboutImage4 {
  grid-column: 6 / -1;
}

@media only screen and (max-width: 768px) {
  .about {
    display: grid;
    grid-template-columns: 1fr;
  }
}

@media only screen and (max-width: 600px) {
  .about__LeftBox {
    display: grid;
    grid-template-columns: 1fr;
  }

  .aboutImage {
    grid-column: 1/ -1;
  }
}
</style> 


